import React from 'react';
import createStore from './store/contentLibraryStore';
import { RootProvider } from '@everfi/reactifi/src/react-on-rails/RootProvider';
import ContentLibraryContainer from './containers/ContentLibraryContainer';
import { HeapTracking } from '../../components/HeapTracking';

export default (props, _railsContext) => {
  const { heapId, user } = props;
  const store = createStore(props || {});
  return () => {
    return (
      <>
        <HeapTracking id={heapId} user={user} />
        <RootProvider store={store}>
          <ContentLibraryContainer
            {...props}
            contentServiceUrl={_railsContext.content_service_url}
            userId={user.id}
            jwt={_railsContext.jwt}
          />
        </RootProvider>
      </>
    );
  };
};
